import { styled } from '@mui/material/styles';
import React from 'react';

const Root = styled('div')(({ theme }) => ({
  height: 'initial',
  minHeight: 'auto',
  flexGrow: 1,
  width: 0, // required for propper flexbox layout
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: theme.palette.common.white,
}));

interface IProps {
  id?: string;
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

export const Page = (props: IProps) => {
  return <Root id={props.id} className={props.className} style={props.style}>{props.children}</Root>;
};
